import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=f884f4bc&scoped=true&"
import script from "./AuthPage.vue?vue&type=script&lang=ts&"
export * from "./AuthPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f884f4bc",
  null
  
)

export default component.exports